// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module--title--1njPf","perksList":"index-module--perksList--1Gp5_","perk":"index-module--perk--33Dtr","perkDescription":"index-module--perkDescription--3gfM9"};